import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import {HttpStatusCodes} from '../../util/uiconstants';
import {cloneDeep, orderBy, isEmpty} from 'lodash';

export default function orgChartReducer(state = initialState.quickFilters, action) {
	switch (action.type) {
		case types.GET_QUICK_FILTERS: {
			//Normalize structure.
			if (!isEmpty(action.response)) {
				return {
					...action.response,
					filters: orderBy(action.response.filters, (filter) => filter['name']?.toLowerCase(), ['asc']).map((f) => {
						return {
							...f,
							isNew: false,
							orgChart: f.orgChart.map((o) => {
								return {
									checked: o.isChecked,
									entityLevel: o.entityLevel,
									id: o.id,
									label: o.entityName,
									parentId: o.parentEntityId
								};
							})
						};
					})
				};
			}
			return state;
		}
		case types.ADD_QUICK_FILTERS: {
			if (action?.responseObj?.request?.status === HttpStatusCodes.Created) {
				let quick = cloneDeep(state);

				if (isEmpty(quick)) {
					quick = {
						...action.response.model,
						filters: []
					};
				}
				quick.filters?.forEach((f) => {
					f.isNew = false;
				});

				quick.filters.push(getFilter(action, true));
				quick.filters = orderBy(quick.filters, (filter) => filter['name']?.toLowerCase(), ['asc']);
				return quick;
			}
			return state;
		}
		case types.EDIT_QUICK_FILTERS: {
			if (action?.responseObj?.request?.status === HttpStatusCodes.Ok) {
				return {
					...state,
					// update edited entry in filters array and sort by name.
					filters: orderBy(
						[...state.filters.filter((f) => f.filterId !== action.filterId), getFilter(action, false)],
						(filter) => filter['name']?.toLowerCase(),
						['asc']
					)
				};
			}
			return state;
		}
		case types.DELETE_QUICK_FILTERS: {
			if (action?.responseObj?.request?.status === HttpStatusCodes.NoContent) {
				return {...state, filters: state.filters.filter((f) => f.filterId !== action.filterId)};
			}
			return state;
		}
		case types.RESET_NEW_FLAG: {
			let resetQuick = cloneDeep(state);
			if (resetQuick) {
				resetQuick.filters.forEach((f) => {
					f.isNew = false;
				});
				return resetQuick;
			}
			return state;
		}
		default:
			return state;
	}
}

const getFilter = (action, isCreated) => {
	return {
		filterId: action.filterId || action.response?.filterId,
		name: action.name,
		orgChart: action.selectedNodes,
		isNew: isCreated
	};
};
